import React, { useEffect, useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { MESSAGE } from '../../../utils/message';
import {
    SectionTitle,
    Title,
    SectionText,
    SendEmailsWrap,
    SendEmailsTitle,
    SendEmailsOuterWrap,
    SendEmailsContent,
    SendEmailsText,
    SendEmailsButtonWrap,
    DownloadButton,
    CopyButton,
    EmailSocialMediaButton,
    SocialMediaButton,
    SendEmailsTextArea,
} from './inviteReviewsStyle'
import { useDispatch, useSelector } from "react-redux";
import { openInNewTab } from "../../../utils/functions";
import { URLs } from "../../../utils/constant";
import { useParams } from "react-router-dom";
import { nonprofitProfileHandler } from "../../../redux/slices/myNonprofit/nonprofitProfile-slice";

const InviteReviewsTabBox = () => {

    const { id } = useParams();
    const nonprofitStats = useSelector((state: any) => state?.nonprofitProfile?.data?.results)
    const dispatch = useDispatch();

    const [emailText, setEmailText] = useState("");

    useEffect(() => {
        dispatch(nonprofitProfileHandler(id) as any);
    }, [id]);

    useEffect(() => {
        if (nonprofitStats?.slug) {
            setEmailText(`
Dear Friend,

If you love our work then tell the world! You have an opportunity to help us make even more of a difference in our community. GreatNonprofits-a review site like TripAdvisor-is honoring highly reviewed nonprofits with their 2024 Top-Rated Awards. Won't you help us raise visibility for our work by posting a review of your experience with us? All reviews will be visible to potential donors and volunteers. It’s easy and only takes 3 minutes!

Go to https://new.greatnonprofits.org/org/${nonprofitStats.slug} to get started!
            `);
        }
    }, [nonprofitStats?.slug]);
    //     const emailText = `
    // Dear Friend,

    // If you love our work then tell the world! You have an opportunity to help us make even more of a difference in our community. GreatNonprofits-a review site like TripAdvisor-is honoring highly reviewed nonprofits with their 2024 Top-Rated Awards. Won't you help us raise visibility for our work by posting a review of your experience with us? All reviews will be visible to potential donors and volunteers. It’s easy and only takes 3 minutes!

    // Go to https://new.greatnonprofits.org/org/${nonprofitStats?.slug} to get started!
    // `;
    const socialMediaTexts = [
        `Help us get a @GreatNonprofits 2024 Top-Rated Award, write a review of your experience with us!
https://new.greatnonprofits.org/org/${nonprofitStats?.slug}`,

        `Take 2 minutes to review us for the @GreatNonprofits Top-Rated Awards!
https://new.greatnonprofits.org/org/${nonprofitStats?.slug}`,

        `Hey volunteers! Review us for the GreatNonprofits Top-Rated Awards!
https://new.greatnonprofits.org/org/${nonprofitStats?.slug}`
    ];
    const smsReviewText = `
To Send an SMS Review

1. Tap New Message on your Message app
2. Enter the number (888) 432 - 6659
3. In the message field, enter the 9-digit EIN of the nonprofit you are writing about
4. Tap Send
5. Now you will be given three questions: a rating, your role and a space to write comments

Your privacy is protected. Your answers are anonymous and your phone number is never shown publicly.

Reviews automatically show up on the nonprofit's profile page. Reviewers are designated mobile users.
`
    const sendEmailTextRef = useRef<HTMLTextAreaElement | null>(null);
    const sendSMSTextRef = useRef<HTMLTextAreaElement | null>(null);
    const socialMediaTextRef = useRef<HTMLDivElement | null>(null);

    const copyToClipboard = () => {
        if (sendEmailTextRef.current) {
            sendEmailTextRef.current.select();
            navigator.clipboard
                .writeText(sendEmailTextRef.current.value);
            sendEmailTextRef.current.focus();
        }
    };
    const copyToClipboardSMS = () => {
        if (sendSMSTextRef.current) {
            sendSMSTextRef.current.select();
            navigator.clipboard
                .writeText(sendSMSTextRef.current.value);
            sendSMSTextRef.current.focus();
        }
    };
    const copyToClipboardSocialMedia = (line: string) => {
        if (socialMediaTextRef?.current) {
            navigator.clipboard
                .writeText(line);
            socialMediaTextRef.current.focus();
        }
    };

    const downloadEmailTemplate = () => {
        const element = document.createElement("a");
        if (sendEmailTextRef?.current) {
            const file = new Blob([sendEmailTextRef.current.value], { type: 'text/plain' });
            element.href = URL.createObjectURL(file);
            element.download = "email_template.txt";
            document.body.appendChild(element);
            element.click();
        }
    };
    const downloadSocialMediaTemplate = () => {
        const content = socialMediaTexts.join('\n\n');
        const element = document.createElement("a");
        const file = new Blob([content], { type: 'text/plain' });
        element.href = URL.createObjectURL(file);
        element.download = "social_media_template.txt";
        document.body.appendChild(element);
        element.click();
    };

    const downloadFlyerTemplate = () => {
        const content = "This is flyer template demo";
        const element = document.createElement("a");
        const file = new Blob([content], { type: 'text/plain' });
        element.href = URL.createObjectURL(file);
        element.download = "flyer_template.docx";
        document.body.appendChild(element);
        element.click();
    }

    return (
        <>
            <SectionTitle>
                <Title>{MESSAGE.inviteReviews}</Title>
                <SectionText>{MESSAGE.copyInviteText}</SectionText>
            </SectionTitle>

            <SendEmailsWrap>
                <SendEmailsTitle>{MESSAGE.sendEmails}</SendEmailsTitle>

                <SendEmailsOuterWrap>
                    <SendEmailsContent>
                        <SendEmailsTextArea
                            id="email_text"
                            name="email_text"
                            rows={12}
                            readOnly
                            defaultValue={emailText}
                            ref={sendEmailTextRef}
                            onFocus={copyToClipboard}
                        />
                    </SendEmailsContent>
                </SendEmailsOuterWrap>

                <SendEmailsButtonWrap>
                    <DownloadButton className='file-download-btn btn btn-primary' onClick={downloadEmailTemplate}>Download email template (.txt)</DownloadButton>

                    <CopyButton className='btn-outline-success-blue btn btn-primary' onClick={copyToClipboard}>Copy to Clipboard</CopyButton>
                </SendEmailsButtonWrap>

            </SendEmailsWrap>

            <SendEmailsWrap>
                <SendEmailsTitle>{MESSAGE.postFacebookTwitter}</SendEmailsTitle>

                <EmailSocialMediaButton>
                    <SocialMediaButton onClick={() => openInNewTab(URLs.facebook)} className='facebook-review-btn btn'>Invite Review on Facebook</SocialMediaButton>
                    <SocialMediaButton onClick={() => openInNewTab(URLs.xURL)} className='twitter-review-btn btn'>Invite Review on Twitter</SocialMediaButton>
                </EmailSocialMediaButton>

                <SendEmailsOuterWrap>
                    {socialMediaTexts.map((text, index) => (
                        <SendEmailsContent key={index + 1} ref={socialMediaTextRef} onClick={() => copyToClipboardSocialMedia(text)}>
                            {text.split('\n').map((line, idx) => (
                                <SendEmailsText key={idx + 1}>{line}</SendEmailsText>
                            ))}
                        </SendEmailsContent>
                    ))}
                </SendEmailsOuterWrap>
                <SendEmailsButtonWrap>
                    <DownloadButton
                        className='file-download-btn btn btn-primary'
                        onClick={downloadSocialMediaTemplate}
                    >
                        Download social media template (.txt)
                    </DownloadButton>
                </SendEmailsButtonWrap>


            </SendEmailsWrap>

            <SendEmailsWrap>
                <SendEmailsTitle>Invite SMS Reviews</SendEmailsTitle>

                <SendEmailsOuterWrap>
                    <SendEmailsContent>
                        <SendEmailsTextArea
                            id="sms_text"
                            name="sms_text"
                            rows={13}
                            readOnly
                            defaultValue={smsReviewText}
                            ref={sendSMSTextRef}
                            onFocus={copyToClipboardSMS}
                        />
                    </SendEmailsContent>

                </SendEmailsOuterWrap>

                <SendEmailsButtonWrap>
                    <DownloadButton className='file-download-btn btn btn-primary' onClick={downloadFlyerTemplate}>Download a flyer template you can edit (.docx)</DownloadButton>
                    <CopyButton className='btn-outline-success-blue btn btn-primary' onClick={copyToClipboardSMS}>Copy to Clipboard</CopyButton>
                </SendEmailsButtonWrap>

            </SendEmailsWrap>

        </>
    )
}

export default InviteReviewsTabBox;
